<template>
  <div class="auth-card">
    <div class="auth-card__background"
         :style="styles"
    />
    <div class="container">
      <a v-if="!logoDisabled" class="logo" :href="homeLink">
        <img :src="appearance.logo"/>
      </a>

      <slot />
    </div>
  </div>
</template>
<script setup>
import {computed} from "vue";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";

const route = useRoute();
const { t } = useI18n();

const props = defineProps({
  ignoreStyles: Boolean,
  logoDisabled: Boolean,
});

const appearance = computed(() => {
  return window.setup.login;
});
const styles = computed(() => {
  if (props.ignoreStyles) return null;
  return {
    backgroundColor: appearance.value.panel_background,
    opacity: 1 - appearance.value.panel_transparency / 100,
  }
});
const homeLink = computed(() => window.setup.home);
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";
@import "bootstrap/scss/functions";
@import "bootstrap/scss/mixins";
@import "bootstrap/scss/variables";

.logo {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0 spacing(11) 0;

  img { max-width: toRem(180); }
}

.auth-card {
  width: 100%;
  max-width: toRem(480);
  padding: spacing(12) spacing(6) spacing(6) spacing(6);
  background-color: themeColor('base');
  border-radius: $border-radius-pill;
  box-shadow: 0 toRem(15) toRem(35) 0 rgba(60, 66, 87, 0.20),
  0 toRem(5) toRem(15) 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;
  position: relative;

  @include media-breakpoint-up(sm) {
    padding: spacing(12) spacing(7) spacing(9) spacing(7);
  }

  :deep(.form-error) {
    margin-bottom: spacing(4);
  }

  &__background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .container {
    z-index: 2;
    position: relative;
  }

  &--forgot-password {
    padding: spacing(10);
  }
}
</style>